<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-icon left>mdi-newspaper</v-icon>
        Manajemen Iklan
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" @click="getAdvertisement">
              <v-icon left>mdi-refresh</v-icon>
              Muat Ulang
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Judul</th>
                  <th class="text-left">Deskripsi</th>
                  <th class="text-left">Gambar</th>
                  <th class="text-left">Target URL</th>
                  <th class="text-left">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="advertisement">
                  <td>{{ advertisement.title }}</td>
                  <td>{{ advertisement.description }}</td>
                  <td>
                    <v-img
                      v-if="advertisement.image_data"
                      :src="advertisement.image_data"
                      max-width="100"
                      max-height="100"
                    ></v-img>
                    <v-img
                      v-else-if="advertisement.image_url"
                      :src="advertisement.image_url"
                      max-width="100"
                      max-height="100"
                    ></v-img>
                  </td>
                  <td>
                    <a :href="advertisement.target_url" target="_blank">{{
                      advertisement.target_url
                    }}</a>
                  </td>
                  <td>
                    <v-btn
                      icon
                      color="primary"
                      @click="editDialog(advertisement)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>Edit Iklan</v-card-title>
        <v-card-text>
          <v-text-field v-model="edit.title" label="Judul"></v-text-field>
          <v-textarea v-model="edit.description" label="Deskripsi"></v-textarea>
          <v-file-input
            v-model="edit.image"
            label="Gambar"
            accept="image/*"
            prepend-icon="mdi-camera"
          ></v-file-input>
          <v-text-field
            v-model="edit.target_url"
            label="Target URL"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false">Batal</v-btn>
          <v-btn color="primary" @click="postAdvertisement">Simpan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      edit: {
        title: "",
        description: "",
        image: null,
        target_url: "",
      },
    };
  },
  computed: {
    advertisement() {
      return this.$store.state.advertisement.advertisement.data;
    },
  },
  methods: {
    getAdvertisement() {
      this.$store.dispatch("getAdvertisement");
    },
    editDialog(item) {
      this.edit = { ...item };
      this.dialog = true;
    },
    postAdvertisement() {
      const formData = new FormData();
      formData.append("image", this.edit.image);
      formData.append("title", this.edit.title);
      formData.append("description", this.edit.description);
      formData.append("target_url", this.edit.target_url);
      this.$store.dispatch("postAdvertisement", formData);
      this.dialog = false;
    },
  },
  mounted() {
    this.getAdvertisement();
    console.log(this.advertisement);
  },
};
</script>
